<template>
  <v-container fluid pt-0 pl-0 pr-0 pb-0 mt-0>
    <v-layout row wrap>
      <v-snackbar :timeout="6000" :top="true" color="#515151" v-model="upgrade">
        {{ 'consumer.upgrade' | t }}
        <v-btn color="white" flat @click="upgrade = false"> {{ 'consumer.close' | t }}</v-btn>
      </v-snackbar>
      <v-flex md2 d-flex class="">
        <v-layout row wrap>
          <v-flex md12 mt-3 d-flex class="background rounded-tabs-sub">
            <v-card-text>
              <v-row align-top class="tw-txt-color-primary">
                <div class="tamany_titol_sitebar">{{ `workers.sitebar.${w_type}.title` | t }}</div>
                <br />
                <p>{{ `workers.sitebar.${w_type}.description` | t }}</p>
                <br />
                <div class="tamany_titol_sitebar">{{ `workers.sitebar.${w_type}.sub_title_01` | t }}</div>
                <br />
                <ul>
                  <li>
                    <b> {{ `workers.sitebar.${w_type}.li_01_title_01` | t }}</b> {{ `workers.sitebar.${w_type}.li_01_text_01` | t }}
                  </li>
                  <li>
                    <b> {{ `workers.sitebar.${w_type}.li_01_title_02` | t }}</b> {{ `workers.sitebar.${w_type}.li_01_text_02` | t }}
                  </li>
                  <li>
                    <b> {{ `workers.sitebar.${w_type}.li_01_title_03` | t }}</b> {{ `workers.sitebar.${w_type}.li_01_text_03` | t }}
                  </li>
                  <li>
                    <b> {{ `workers.sitebar.${w_type}.li_01_title_04` | t }}</b> {{ `workers.sitebar.${w_type}.li_01_text_04` | t }}
                  </li>
                </ul>
                <br />
                <div class="tamany_titol_sitebar">{{ `workers.sitebar.${w_type}.sub_title_02` | t }}</div>
                <br />
                <p>{{ `workers.sitebar.${w_type}.sub_description_02` | t }}</p>
                <br />
                <ul>
                  <li>
                    {{ `workers.sitebar.${w_type}.li_02_text_01` | t }}
                  </li>
                  <li>
                    {{ `workers.sitebar.${w_type}.li_02_text_02` | t }}
                  </li>
                  <li>
                    {{ `workers.sitebar.${w_type}.li_02_text_03` | t }}
                  </li>
                </ul>

                <br />
                <div class="tamany_titol_sitebar">{{ `workers.sitebar.${w_type}.tips_title` | t }}</div>
                <br />
                <ul>
                  <li>
                    {{ `workers.sitebar.${w_type}.li_tips_01` | t }}
                  </li>
                  <li>
                    {{ `workers.sitebar.${w_type}.li_tips_02` | t }}
                  </li>
                </ul>
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md10>
        <v-flex md12 class="mt-3">
          <v-flex>
            <div class="headline tw-txt-color-primary ml-3 subtitol rounded-tabs-sub">{{ 'workers.subtitle' | t }}</div>
          </v-flex>
          <v-snackbar :timeout="3000" :top="true" color="#515151" v-model="info_create">
            {{ 'workers.status_update' | t }}
            <v-btn color="white" flat @click="info_create = false">Close</v-btn>
          </v-snackbar>
          <v-layout>
            <v-flex md3 d-flex v-if="w_type == 'instagram'">
              <v-card v-if="getConsumer('instagram').counter > 0" flat>
                <workers-form-insta
                  v-if="getConsumer('instagram').counter > 0"
                  :token="token"
                  :btnact="getConsumer('instagram').counter > 0"
                  :w_type="w_type"
                  :words_limit="getConsumer('instagram').words_limit"
                  @updateworkers="getChange()"
                  @actualizarUpgrade="actualizarUpgradeEnA()"
                />
              </v-card>
              <v-card v-else flat>
                <v-card-text class="tw-txt-color-primary">
                  {{ 'workers.more' | t }}
                  <br />
                  <b>{{ 'workers.email' | t }}</b>
                  <br />
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md3 d-flex v-if="w_type == 'facebook'">
              <v-card v-if="getConsumer('facebook').counter > 0" flat>
                <workers-form-face
                  v-if="getConsumer('facebook').counter > 0"
                  :token="token"
                  :btnact="getConsumer('facebook').counter > 0"
                  :w_type="w_type"
                  :words_limit="getConsumer('facebook').words_limit"
                  @updateworkers="getChange()"
                  @actualizarUpgrade="actualizarUpgradeEnA()"
                />
              </v-card>
              <v-card v-else flat>
                <v-card-text class="tw-txt-color-primary">
                  {{ 'workers.more' | t }}
                  <br />
                  <b>{{ 'workers.email' | t }}</b>
                  <br />
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md3 d-flex v-if="w_type == 'twitter'">
              <v-card v-if="getConsumer('twitter').counter > 0" flat>
                <workers-form-twit
                  :token="token"
                  :btnact="getConsumer('twitter').counter > 0"
                  :w_type="w_type"
                  :words_limit="getConsumer('twitter').words_limit"
                  @updateworkers="getChange()"
                  @actualizarUpgrade="actualizarUpgradeEnA()"
                />
              </v-card>
              <v-card v-else flat>
                <v-card-text class="tw-txt-color-primary">
                  {{ 'workers.more' | t }}
                  <br />
                  <b>{{ 'workers.email' | t }}</b>
                  <br />
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md3 d-flex v-if="w_type == 'newspro'">
              <v-card v-if="getConsumer('newspro').counter > 0" flat>
                <workers-form-twit
                  :token="token"
                  :btnact="getConsumer('newspro').counter > 0"
                  :w_type="w_type"
                  :words_limit="getConsumer('newspro').words_limit"
                  @updateworkers="getChange()"
                  @actualizarUpgrade="actualizarUpgradeEnA()"
                />
              </v-card>
              <v-card v-else flat>
                <v-card-text class="tw-txt-color-primary">
                  {{ 'workers.more' | t }}
                  <br />
                  <b>{{ 'workers.email' | t }}</b>
                  <br />
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md9>
              <workers-resumen :w_type="w_type" />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12>
              <v-card v-for="wk in workers" :key="wk.description" flat>
                <worker-detail :worker_detail="wk" :token="token" :w_type="w_type" @updateworkers="getChange()" />
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <faqs></faqs>
  </v-container>
</template>

<script>
import WorkersResumen from '@/components/Workers/WorkersResumen'
import WorkerDetail from '@/components/Workers/WorkerDetail'
import WorkersFormInsta from '@/components/Workers/WorkersFormInsta'
import WorkersFormFace from '@/components/Workers/WorkersFormFace'
import WorkersFormTwit from '@/components/Workers/WorkersFormTwit'
//import WorkersFormNews from "@/components/Workers/WorkersFormNews";
import Faqs from '@/components/Faqs'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    WorkersResumen,
    WorkerDetail,
    WorkersFormInsta,
    WorkersFormFace,
    WorkersFormTwit,
    //WorkersFormNews,
    Faqs
  },
  computed: {
    ...mapGetters(['getConsumer', 'getUserId', 'getServer', 'getTokenHeader', 'getColor', 'getColorLow'])
  },
  props: ['w_type', 'token'],
  data: () => ({
    workers: [],
    formload: true,
    info_create: false,
    upgrade: false
  }),
  created() {
    this.getAll()
  },
  methods: {
    ...mapActions(['setMyConsumers', 'rmKey']),
    getChange() {
      this.getAll()
      this.info_create = true
    },
    getAll() {
      const userid = this.user ? parseInt(this.user, 0) : this.getUserId
      this.$http
        .get(`${this.getServer}/users/${userid}/consumers`, this.getTokenHeader)
        .then(data => {
          if (data.data) {
            this.setMyConsumers(data.data)
            const consumer = this.getConsumer(this.w_type)
            return this.$http.get(`${window.location.protocol}//${this.w_type}.trawlingweb.com/workers?token=${consumer.token}`)
          }
        })
        .then(data => {
          this.workers = data.data.response.workers
          this.formload = false
        })
    },
    actualizarUpgradeEnA() {
      this.upgrade = true
    }
  }
}
</script>
<style scoped>
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.tamany_titol {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.tamany_titol_sitebar {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.ratlla {
  height: 3px !important;
}
.subtitol {
  padding-top: 8px !important;
  padding-left: 20px !important;
  background-color: #f2f2f2 !important;
  padding-bottom: 6px !important;
}
.nobot {
  padding-bottom: 0px !important;
}
.background {
  /*background-color: rgb(241 85 80 / 15%) !important;*/
  background: linear-gradient(to bottom, rgb(241 85 80 / 15%), #ffffff) !important; /* De rojo a blanco */
}

.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
